import { CheckoutSteps } from '@yme/components/CheckoutForm/constants';
export const getCurrentFormName = (labels) => {
    const formHeaderLabels = new Map([
        [`#${CheckoutSteps.CART}`, labels.checkout_shoppingCartStep_title],
        [`#${CheckoutSteps.SHIPPING_DETAILS}`, labels.checkout_heroShippingDetailsStep_title],
        [`#${CheckoutSteps.ORDER_REVIEW}`, labels.checkout_heroOrderReviewStep_title],
        [`#${CheckoutSteps.PAYMENT}`, labels.checkout_heroPaymentStep_title],
        [`#${CheckoutSteps.SUCCESS}`, labels.checkout_heroThankYouStep_title],
        [`#${CheckoutSteps.THANK_YOU}`, labels.checkout_heroRequestOrderThankYouStep_title],
    ]);
    return formHeaderLabels.get(window.location.hash) || ' ';
};
export function getQueryParam(name) {
    const q = window.location.href.match(new RegExp('[?&]' + name + '=([^&#]*)'));
    return q && q[1];
}
export const harmonizeLink = (link) => link.indexOf('?') > -1 ? link.substring(0, link.indexOf('?')) : link;
